(function () {
  function splitHeroTitle(root) {
    var title = root.querySelector('[data-rvrn-hero-title]');
    if (!title || title.dataset.rvrnReady === 'true') return;
    title.dataset.rvrnReady = 'true';

    var anim = root.getAttribute('data-rvrn-hero-anim') || 'letter-in';
    var showCursor = root.getAttribute('data-rvrn-hero-cursor') !== 'false';
    var accentWord = (title.getAttribute('data-rvrn-accent-word') || '').toUpperCase();
    var sourceLines = Array.prototype.slice.call(title.querySelectorAll('[data-rvrn-hero-line]'));
    if (!sourceLines.length) return;

    if (anim === 'none') return;

    var delay = 0;
    title.innerHTML = '';

    sourceLines.forEach(function (source, lineIndex) {
      var lineText = source.textContent || '';
      var line = document.createElement('span');
      line.className = 'rvrn-home-hero__title-line';
      if (source.getAttribute('data-rvrn-accent-line') === 'true') {
        line.className += ' rvrn-home-hero__title-line--accent';
      }

      lineText.split(/\s+/).filter(Boolean).forEach(function (word) {
        var wordEl = document.createElement('span');
        wordEl.className = 'rvrn-home-hero__title-word';
        if (accentWord && word.toUpperCase().replace(/[^\w]/g, '') === accentWord.replace(/[^\w]/g, '')) {
          wordEl.className += ' is-accent';
        }

        word.split('').forEach(function (char) {
          var letter = document.createElement('span');
          letter.className = 'rvrn-home-hero__letter';
          letter.textContent = char;
          if (anim === 'letter-in') {
            letter.style.animationDelay = delay + 'ms';
          }
          wordEl.appendChild(letter);
          delay += 55;
        });

        line.appendChild(wordEl);
        delay += 66;
      });

      title.appendChild(line);
      delay += lineIndex === sourceLines.length - 1 ? 0 : 120;
    });

    if (showCursor) {
      var cursor = document.createElement('span');
      cursor.className = 'rvrn-home-hero__cursor';
      var lastLine = title.querySelector('.rvrn-home-hero__title-line:last-child');
      if (lastLine) lastLine.appendChild(cursor);
    }
  }

  function playVideos(root) {
    var videos = root.querySelectorAll('video');
    videos.forEach(function (video) {
      if (video.dataset.rvrnHeroVideoReady === 'true') return;
      video.dataset.rvrnHeroVideoReady = 'true';
      video.addEventListener('loadedmetadata', function () {
        try {
          if (video.duration > 2) video.currentTime = 1.2;
        } catch (e) {}
        var play = video.play();
        if (play && play.catch) play.catch(function () {});
      }, { once: true });
    });
  }

  /* 「U.S. states」自动统计 block。
     归一化实现放在 assets/rvrn-us-states.js（本 Section 独有引用）。
     口径与 Section rvrn-vehicle-gallery 的 Stat 5 一致（全量有效原始记录、
     按 2 位州缩写去重）；但该 Section 目前仍自带一份等价实现、未迁移过来，
     所以两边还不是同一份代码 —— 改任何一边的口径都必须同步另一边。
     数值未到位前保持 Liquid 输出的 0，不去动它，以免出现空值造成的布局位移。 */
  function initStatesStats(hero) {
    var holders = hero.querySelectorAll('[data-rvrn-states-stat]');
    if (!holders.length) return;

    var pending = [];
    holders.forEach(function (holder) {
      if (holder.dataset.rvrnStatesReady === 'true') return;
      var valueEl = holder.querySelector('.rvrn-stat__value');
      if (valueEl) pending.push({ holder: holder, valueEl: valueEl });
    });
    if (!pending.length) return;

    if (!window.RVRNUsStates) {
      console.warn('[rvrn-home-hero] states stat: rvrn-us-states.js 未加载，统计跳过');
      return;
    }

    var token = hero.getAttribute('data-storefront-token');
    if (!token) {
      console.warn('[rvrn-home-hero] states stat: 缺少 storefront_token，统计跳过');
      return;
    }

    window.RVRNUsStates.loadStateCount({
      token: token,
      version: hero.getAttribute('data-api-version') || '2024-01',
      handle: hero.getAttribute('data-states-blog') || 'vehicle-gallery',
      regionMetafield: hero.getAttribute('data-states-region-metafield') || 'custom.customer_location'
    }).then(function (count) {
      pending.forEach(function (item) {
        item.valueEl.textContent = String(count);
        // 「已处理」标记只在数值真正写入后才打。之前在取值/检查之前就打，
        // 一旦那次尝试没成功（模块未加载、请求失败），区块会被永久跳过，
        // 编辑器里就一直显示 0，直到区块 DOM 被整体替换才恢复。
        item.holder.dataset.rvrnStatesReady = 'true';
      });
    }).catch(function (err) {
      console.warn('[rvrn-home-hero] states stat failed →', err && err.message);
    });
  }

  function init(scope) {
    var root = scope || document;
    var heroes = [];
    // scope 本身可能就是 hero 根节点（主题编辑器 shopify:section:load 传入 section 元素），
    // querySelectorAll 只匹配后代，必须单独判断，否则重载后所有初始化都不会执行。
    if (root.matches && root.matches('[data-rvrn-home-hero]')) heroes.push(root);
    root.querySelectorAll('[data-rvrn-home-hero]').forEach(function (hero) {
      heroes.push(hero);
    });

    heroes.forEach(function (hero) {
      splitHeroTitle(hero);
      playVideos(hero);
      initStatesStats(hero);
      if (window.RVRNBuilder) window.RVRNBuilder.bindExternalCtas(hero);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    if (window.RVRNReveal && window.RVRNReveal.init) {
      window.RVRNReveal.init(event.target);
    }
  });
})();
